<template>
  <div>
    <PurchasedHeader
      style="width: 100%"
      @custom-event="handleEvent"
      :userName="userName"
      :placeholderText="'搜索知识资源'"
    />
    <div class="putbaseBanner">
      <div class="banner_img">{{ userName }}，欢迎使用亿知知识库</div>
    </div>

    <div class="purchaseList_content">
      <div class="yigou_shiyong_list">
        <!-- 已购产品部分 -->
        <div class="yigou_list" v-loading="loading" >
          <div class="yigou_title">
            <div class="yigou_title_text">产品</div>
            <div class="yigouiconnumber">
              <div v-if="yigouDataList.length > 0 ">
                共<span>{{ yigouDataList.length }}</span
                >个数据库 <span style="color: #1c6bfb">{{ currentPage }}</span
                >/
                <span>{{ totalPages }}</span>
              </div>
              <div class="yigou_icon" v-if="yigouDataList.length > 0 ">
                <div @click="prevPage" :class="{ disabled: currentPage === 1 }">
                  <img :src="yigou_left" alt="上一页" />
                </div>
                <div
                  @click="nextPage"
                  :class="{ disabled: currentPage === totalPages }"
                >
                  <img :src="yigou_right" alt="下一页" />
                </div>
              </div>
              
            </div>
          </div>
          <div class="yigou_list_item" v-if="yigouDataList.length > 0 ">
            <div
              class="yigou_item"
              v-for="(item, index) in paginatedData"
              :key="index"
            >
              <div class="yigou_img" v-if="item?.imgUrl">
                <img
                  :src="getImagePath2(item?.imgUrl)"
                  style="width: 160px; height: 90px; border: 1px solid #ebeef5;cursor: pointer;"
                  @mouseenter="showBigImg(item?.imgUrl, $event)"
                  @click="openIfraem(item)"
                  @mouseleave="hideBigImg(item?.imgUrl, $event)"
                  alt=""
                />
              </div>
              <div class="yigou_right_content">
                <div class="yigou_content_title">
                  <div
                    class="yigou_content_text_title"
                    @click="openIfraem(item)"
                  >
                    {{ item?.title }}
                    <span class="yg_fwfs">
                      {{ item.versionType === "0" ? "网络版本" : "镜像版本" }}
                    </span>
                  </div>
                  <div v-if="showExpiredIcon(item.expireTime)" class="gqimg">
                    <img :src="guoqi" alt="" />
                  </div>
                  <div style="font-size: 12px;color:#999">{{getYearMonth(item.expireTime)}}  到期</div>
                </div>
                <div class="yigou_center_tent">
                  <div class="yuanqu-con">
                    <div class="text">
                      <span
                        class="btn"
                        @click="lookmore"
                        v-if="item?.description && item.isOverflow"
                      >
                        <CustomPopoverKnow placement="bottom">
                          <template #trigger>
                            <div>
                              查看更多
                            </div>
                          </template>
                          <template #content>
                            <div class="popover-desc">
                              <p
                                style="
                                  font-size: 14px;
                                  color: #333;
                                  font-weight: bold;
                                  margin-bottom: 20px;
                                "
                              >
                                {{ item?.title }}
                              </p>
                              <p v-html="item?.description || '暂无简介'"></p>
                            </div>
                          </template>
                        </CustomPopoverKnow>
                      </span>

                      <div
                        :ref="el => setTextRef(el, index)"
                        v-html="item?.description || '暂无简介'"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <transition name="fade">
              <div
                class="image-box-viewer"
                id="imageBoxViewer"
                :style="{
                  top: `${imgPosition.top}px`,
                  left: `${imgPosition.left}px`,
                  border: 'none',
                  position: 'absolute',
                  width: '950px',
                  zIndex: '99',
                }"
                v-if="bigImgVisable"
              >
                <div
                  class="viewer-image"
                  style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)"
                >
                  <img style="width: 100%" :src="bigImg" />
                </div>
              </div>
            </transition>
          </div>

          <div class="yigou_list_kong" v-if="yigouDataList.length == 0 ">
            <div>
              <img :src="kongzt" alt="">
              <p>暂无已购知识库</p>
            </div>
          </div>
        </div>

        <!-- 试用产品部分 -->
        <div class="yigou_list" v-loading="loading2"  >
          <div class="yigou_title">
            <div class="yigou_title_text">试用产品</div>
            <div class="yigouiconnumber">
              <div v-if="shiyongDataList.length > 0 ">
                共<span>{{ shiyongDataList.length }}</span
                >个数据库 <span style="color: #1c6bfb">{{ currentPage2 }}</span
                >/
                <span>{{ totalPages2 }}</span>
              </div>
              <div class="yigou_icon"  v-if="shiyongDataList.length > 0 ">
                <div
                  @click="prevPage2"
                  :class="{ disabled: currentPage2 === 1 }"
                >
                  <img :src="yigou_left" alt="上一页" />
                </div>
                <div
                  @click="nextPage2"
                  :class="{ disabled: currentPage2 === totalPages2 }"
                >
                  <img :src="yigou_right" alt="下一页" />
                </div>
              </div>
            </div>
          </div>
          <div class="yigou_list_item">
            <div
              class="yigou_item"
              v-for="(item, index) in paginatedShiyongData"
              :key="index"
            >
              <div class="yigou_img" v-if="item?.imgUrl">
                <img
                  :src="getImagePath2(item?.imgUrl)"
                  @mouseenter="showBigImg(item?.imgUrl, $event)"
                  @click="openIfraem(item)"
                  @mouseleave="hideBigImg(item?.imgUrl, $event)"
                  style="width: 160px; height: 90px; border: 1px solid #ebeef5;cursor: pointer;"
                  alt=""
                />
              </div>
              <div class="yigou_right_content">
                <div class="yigou_content_title">
                  <div
                    class="yigou_content_text_title"
                
                  >
                  <span class="yg_title" @click="openIfraem(item)">  {{ item?.title }}</span>
                    <span class="yg_fwfs">
                      {{ item.versionType === "0" ? "网络版本" : "镜像版本" }}
                    </span>
                      <span class="yg_fwfs" v-if="item.loginName && item.loginPassword">
                      账号登录
                    </span>
                    <span style="margin-left:10px;font-size:10px;color:#999;" v-if="item.loginName && item.loginPassword">
                      账号：{{item.loginName}} 密码：{{ item.loginPassword}}
                    </span>
                      <span class="yg_fwfs" v-if="!item.loginName && !item.loginPassword">
                      IP登录
                    </span>
                  </div>
                    <div v-if="showExpiredIcon(item.expireTime)" class="gqimg">
                    <img :src="guoqi" alt="" />
                  </div>
                    <div style="font-size: 12px;color:#999">{{getYearMonth(item.expireTime)}}  到期</div>
                </div>
                <div class="yigou_center_tent">
                  <div class="yuanqu-con">
                    <div class="text">
                      <span class="btn" @click="lookmore">
                        <CustomPopoverKnow placement="bottom">
                          <template #trigger>
                            <div v-if="item?.description && item.isOverflow">查看更多</div>
                          </template>
                          <template #content>
                            <div class="popover-desc">
                              <p
                                style="
                                  font-size: 14px;
                                  color: #333;
                                  font-weight: bold;
                                  margin-bottom: 20px;
                                "
                              >
                                {{ item?.title }}
                              </p>
                              <p v-html="item?.description || '暂无简介'"></p>
                            </div>
                          </template>
                        </CustomPopoverKnow>
                      </span>

                      <div
                        v-html="item?.description || '暂无简介'"
                        class="text-con"
                        :ref="el => setTextRef1(el, index)"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="yigou_list_kong"  v-if="shiyongDataList.length == 0 ">
            <div>
              <img :src="kongzt" alt="">
              <p>暂无试用知识库</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tjcp_list">
      <div class="tjcp_content">
        <div class="yigou_title">
          <div class="yigou_title_text">推荐产品</div>
        </div>
        <div class="tjcp_carousel">
          <!-- 左箭头 -->
          <div
            class="tjcp_arrow tjcp_arrow_left"
            @click="prevTjcpPage"
            :class="{ disabled: currentTjcpPage === 1 }"
          >
            <img :src="tjcp_left" alt="上一页" />
          </div>

          <!-- 内容区域 -->
          <div class="tjcp_list_wrapper">
            <div
              class="tjcp_list_item"
              :style="{
                transform: `translateX( ${(currentTjcpPage - 1) * -1000}px)`,
              }"
            >
              <div
                class="tjcp_item"
                v-for="(item, index) in tjcpDataList"
                :key="index"
              >
                <img
                  @click="datebaseinfo(item)"
                  :src="getImagePath2(item?.imgUrl)"
                  alt=""
                />
                <div class="tjcp_title_text" @click="datebaseinfo(item)">
                  {{ item?.title }}
                </div>
                <div class="tjcp_icon_list">
                  <div class="tjcp_fwfs">
                    <img :src="wlfw" alt="" />
                    <p>网络访问 | 镜像访问</p>
                  </div>
                  <div class="tjcp_jianjie" @click="handlejpzskinffo(item)">
                    <img :src="jjicon" alt="简介" />
                    <p>简介</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 右箭头 -->
          <div
            class="tjcp_arrow tjcp_arrow_right"
            @click="nextTjcpPage"
            :class="{
              disabled:
                currentTjcpPage >=
                Math.ceil(tjcpDataList.length / itemsPerPage),
            }"
          >
            <img :src="tjcp_right" alt="下一页" />
          </div>
        </div>
      </div>
      <transition name="fade">
        <div v-if="jzzsktype" class="overlay" @click="handlejpzskinffo"></div>
      </transition>

      <transition name="popover">
        <div class="zpzsk_Popover" v-if="jzzsktype">
          <p class="jpzsk_title">{{ currentItem?.title }}</p>
          <p
            class="jpzsk_content"
            v-html="currentItem?.description || '暂无简介'"
          ></p>
        </div>
      </transition>
    </div>
    <AppFooter />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, nextTick, watchEffect,watch } from "vue";
import PurchasedHeader from "@/views/components/PurchasedHeader.vue";
import { Cookie } from "@/utils/Cookie";
import yigou_left from "@/assets/yylyimages/yigou_left.png";
import yigou_right from "@/assets/yylyimages/yigou_right.png";
import { PostOrderUserList, UpKnowledgeBaseList } from "@/api/index.js";
import AppFooter from "@/views/components/AppFooter.vue";
import CustomPopoverKnow from "@/views/components/CustomPopoverKnow.vue";
import wlfw from "@/assets/newimages/wlfw.png";
import jjicon from "@/assets/newimages/jjicon.png";
import tjcp_left from "@/assets/yylyimages/tjcpleft.png";
import tjcp_right from "@/assets/yylyimages/tjcpright.png";
import kongzt from "@/assets/headerimage/shoppingImage.png";
import guoqi from "@/assets/yylyimages/guoqi.png";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();
const userName = ref("");
const yigouDataList = ref([]);
const jzzsktype = ref(false);
const loading = ref(true);
const loading2 = ref(true);
const shiyongDataList = ref([]);
const currentItem = ref([]);
const tjcpDataList = ref([]);
const imgPosition = ref({
  top: 0,
  left: 0,
  width: 0,
});
const bigImg = ref(null);
const bigImgVisable = ref(false);
// 已购产品分页
const currentPage = ref(1);
const pageSize = 4;
const totalPages = computed(() =>
  Math.ceil(yigouDataList.value.length / pageSize)
);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * pageSize;
  const end = start + pageSize; 
  return yigouDataList.value.slice(start, end);
});

// 试用产品分页
const currentPage2 = ref(1);
const pageSize2 = 4;
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get("userInfo")) || null;
    const user = userString || null;
    userName.value = user?.realName;
  }
};
const openIfraem = (dataUrl) => {
  if (dataUrl.isIframe == "0") {
    window.open(dataUrl.webUrl, "_blank");
  } else {
    if (dataUrl.webUrl) {
      // 构建完整的路由URL
      const routeUrl = router.resolve({
        name: "iframesy",
        query: {
          name: dataUrl.webUrl,
          knowledgeId: dataUrl.id,
          isIfream: dataUrl.isIframe,
          istype: "1",
        },
      }).href;

      // 在新窗口打开
      window.open(routeUrl, "_blank");
    } else {
      ElMessage.warning("暂无试用，请联系销售人员");
    }
  }
};



  const textRefs = ref([]);

  const setTextRef = (el, index) => {
    if (el) {
      textRefs.value[index] = el;
    }
  };
  const textRefs1 = ref([]);

  const setTextRef1 = (el, index) => {
    if (el) {
      textRefs1.value[index] = el;
    }
  };
  const checkAllOverflow = () => {
    paginatedData.value.forEach((item, index) => {
      const el = textRefs.value[index];
      item.isOverflow = el && el.scrollHeight > el.clientHeight;
      // console.log( item.isOverflow ,'llll');
      
    });
  };
  const checkAllOverflow1 = () => {
    paginatedShiyongData.value.forEach((item, index) => {
      const el = textRefs1.value[index];
      item.isOverflow = el && el.scrollHeight > el.clientHeight;
    });
  };
const showBigImg = (url, event) => {
  // console.log(event,url);

  const clickElement = event.currentTarget;
  const rect = clickElement.getBoundingClientRect();

  // 创建临时图片获取尺寸
  const tempImg = new Image();
  tempImg.src = getImagePath2(url);

  tempImg.onload = () => {
  // debugger
    const imgWidth1 = tempImg.width;
    const imgHeight1 = tempImg.height;

    const imgWidth = 950;
    const imgHeight = Math.ceil((imgHeight1 * 950) / imgWidth1);

    // 获取视口尺寸
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    let left = rect.left + window.scrollX - imgWidth - 10;

    if (left < window.scrollX) {
      left = rect.right + window.scrollX + 10;
    }

    // 垂直居中对齐触发元素
    let top = rect.top + window.scrollY;
    // 确保图片不超出视口底部
    if (rect.top > viewportHeight - imgHeight) {
      top =
        rect.top +
        window.scrollY +130-
        136 -
        (imgHeight - (viewportHeight - rect.top));
    } else {
      top = top;
    }

    imgPosition.value = {
      top,
      left,
      width: imgWidth,
    };

    bigImg.value = getImagePath2(url);
    bigImgVisable.value = true;
  };

  tempImg.onerror = () => {
    console.error("图片加载失败:", url);
  };
};

const totalPages2 = computed(() =>
  Math.ceil(shiyongDataList.value.length / pageSize2)
);
const paginatedShiyongData = ref([]);

watchEffect(() => {
  const start = (currentPage2.value - 1) * pageSize2;
  const end = start + pageSize2;
  paginatedShiyongData.value = shiyongDataList.value.slice(start, end);

});

const handlejpzskinffo = (item) => {
  currentItem.value = item;
  jzzsktype.value = !jzzsktype.value;

  // 禁止/恢复滚动
  if (jzzsktype.value) {
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${15}px`;
  } else {
    document.body.style.overflow = "";
    document.body.style.paddingRight = `${0}px`;
  }
};

// 已购产品翻页方法
const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
            checkAllOverflow()
            // checkAllOverflow1()

  }
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
        checkAllOverflow()
        // checkAllOverflow1()

  }
};

// 试用产品翻页方法（修复了之前的问题）
const prevPage2 = () => {
  if (currentPage2.value > 1) {
    currentPage2.value--;
            checkAllOverflow1()
            // checkAllOverflow()

  }
};
const nextPage2 = () => {
  if (currentPage2.value < totalPages2.value) {
    currentPage2.value++;
    checkAllOverflow1()
    // checkAllOverflow()
  }
};

watch(paginatedData, () => {
  nextTick(() => {
    checkAllOverflow();
  });
});

watch(paginatedShiyongData, () => {
  nextTick(() => {
    checkAllOverflow1();
  });
});

// 获取数据方法
const getyigouLidt = async () => {
  const res = await PostOrderUserList({ sy: "1" });
  if (res.info) {
    yigouDataList.value = res.info;
    currentPage.value = 1;
    loading.value = false;
  }
};

const getshiyongLidt = async () => {
  const res = await PostOrderUserList({
    sy: "0",
    pageIndex: "1",
    pageSize: "100", // 获取全部数据，前端分页
  });
  if (res.info) {
    shiyongDataList.value = res.info;
    currentPage2.value = 1;
    loading2.value = false;
  }
};

const gettjcpList = async () => {
  const res = await UpKnowledgeBaseList({ contentCId: "", pageSize: "20" });
  if (res.info) {
    tjcpDataList.value = res.info;
  }
};
const hideBigImg = () => {
  bigImgVisable.value = false;
};

// 图片路径处理
const getImagePath2 = (filePath) => {
  const baseApi = process.env.VUE_APP_BASE_API;
  if (baseApi) {
    return process.env.VUE_APP_BASE_API + "/ckbop" + filePath;
  } else {
    return "/ckbop" + filePath;
  }
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false;
  } catch (e) {
    return true;
  }
};
// 在script setup中添加
const currentTjcpPage = ref(1);
const itemsPerPage = 4; // 每页显示4个产品

const prevTjcpPage = () => {
  if (currentTjcpPage.value > 1) {
    currentTjcpPage.value--;
  }
};

const nextTjcpPage = () => {
  const totalPages = Math.ceil(tjcpDataList.value.length / itemsPerPage);
  if (currentTjcpPage.value < totalPages) {
    currentTjcpPage.value++;
  }
};

const datebaseinfo = (data) => {
  // console.log(data,'lll');

  localStorage.setItem("lastSelectTime", Date.now().toString());
  router.push({
    name: "newDatabaseInfo",
    query: { id: data.id },
  });
};

const showExpiredIcon = (time) => {
  if (!time) return false;

  const expireDate = new Date(time);
  const now = new Date();

  return expireDate < now;
};
const getYearMonth = (str) => {
  var year = str.substring(0, 4);
  var month = str.substring(5, 7);
  var formattedDay = str.substring(8,10);
  return year + "-" + month + "-" + formattedDay;
};
onMounted(async () => {
  await checkTokenStatus();
  await getyigouLidt();
  await getshiyongLidt();
  await gettjcpList();
  checkAllOverflow();
  checkAllOverflow1();
});
</script>

<style lang="scss" scoped>
/* 原有样式保持不变 */

.putbaseBanner {
  width: 100%;
  display: flex;
  justify-content: center;
}
.banner_img {
  width: 1000px;
  height: 150px;
  background-image: url(@/assets/yylyimages/purchasebanner.png);
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: 500;
  text-align: LEFT;
  color: #022250;
}
.purchaseList_content {
  width: 100%;
  display: flex;
  justify-content: center;
}
.yigou_shiyong_list {
  width: 1000px;
}
.yigou_icon {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.yigou_icon div img {
  width: 14px;
  height: 15px;
}
.yigou_title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
}
.yigouiconnumber {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 12px;
  font-weight: 400;
  color: #999999;
}
.yigou_title_text {
  font-size: 18px;
  font-weight: 500;
  position: relative;
  padding-left: 8px;
}
.yigou_title_text::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 5px;
  height: 16px;
  bottom: 0;
  width: 3px;
  background: #1c6bfb;
}
.yigou_item {
  width: 100%;
  height: 130px;
  display: flex;
  padding-top: 20px;
    position: relative;

}
.yigou_item:hover {
  background: #f1f6ff;
  .yg_jianjie {
    background: #f1f6ff;
  }
  // cursor: pointer;
}
.yigou_img,
.yigou_img img {
  width: 160px;
  height: 90px;
}
.yigou_content_title {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  // padding-top: 8px;
}
.gqimg {
  position: absolute;
  right: 0;
  top: 0;
  width: 60px;
  height: 32px;
}
.gqimg img {
  width: 60px;
  height: 32px;
}
.yigou_content_text_title {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.yg_title:hover {
  cursor: pointer;
  color: #1c6bfb;
}
.tjcp_title_text:hover {
  color: #1c6bfb !important;
  cursor: pointer;
}
.yigou_center_tent {
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}

.tjcp_content {
  width: 1000px;
}
.tjcp_item > img {
  width: 235px;
  height: 132px;
}
.tjcp_item .tjcp_title_text {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
}

.yigou_right_content {
  padding-left: 15px;
  border-bottom: 1px solid #e4e7ed;
  padding-right: 25px;
}

.tjcp_list {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  margin-bottom: 40px;
}
.tjcp_content {
  width: 1000px;
}
.tjcp_item > img {
  width: 230px;
  height: 132px;
}
.tjcp_item:hover > img {
  animation: zoomInOut 1s ease;
  cursor: pointer;
}
@keyframes zoomInOut {
  0% {
    transform: scale(1); /* 初始大小 */
  }
  50% {
    transform: scale(0.9); /* 缩小到 90% */
  }
  100% {
    transform: scale(1); /* 放大到 110% */
  }
}
.tjcp_item .tjcp_title_text {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  margin-top: 15px;
}
.tjcp_icon_list {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  margin-top: 15px;
}
.tjcp_list_item {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  // padding: 0 20px;
}

.tjcp_jianjie:hover {
  color: #1c6bfb;
  cursor: pointer;
}
.tjcp_jianjie {
  display: flex;
  align-items: center;
  gap: 4px;
}
.tjcp_jianjie img {
  width: 12px;
  height: 13px;
  gap: 4px;
}
.tjcp_fwfs {
  display: flex;
  align-items: center;
  gap: 4px;
}
.tjcp_fwfs img {
  width: 12px;
  height: 13px;
}

.tjcp_carousel {
  position: relative;
  width: 100%;
  // overflow: hidden;
  padding: 0 10px;
}

.tjcp_list_wrapper {
  width: 100%;
  overflow: hidden;
}

.tjcp_list_item {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  transition: transform 0.3s ease;
  width: 100%;
}

.tjcp_arrow {
  position: absolute;
  top: 100px;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  // background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  // box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.tjcp_arrow:hover {
  background: rgba(255, 255, 255, 0.9);
}

.tjcp_arrow.disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.tjcp_arrow_left {
  left: -19px;
}

.tjcp_arrow_right {
  right: -19px;
}

.tjcp_arrow img {
  width: 18px;
  height: 18px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.zpzsk_Popover {
  position: absolute;
  width: 390px;
  max-height: 490px;
  line-height: 1.6;
  padding-right: 15px;
  padding-left: 10px;
  background: #fff;
  z-index: 9999;
  padding: 20px;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  top: 288px;
}
.jpzsk_title {
  padding-bottom: 20px;
  font-size: 14px;
  color: #333;
  font-weight: bold;
}
.zpzsk_Popover .jpzsk_content {
  font-size: 14px;
  color: #333;
}
.intro-btn {
  padding: 4px 10px;
}
.yg_fwfs {
  width: 60px;
  height: 24px;
  text-align: center;
  border: 1px solid rgb(249, 118, 25);
  color: rgb(249, 118, 25);
  font-size: 10px;
  margin-left: 10px;
  cursor: text;
}

.yuanqu-con {
  // width: 1139px;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  margin-top: 8px;
   text-align: justify;
  .text {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .text::before {
    content: "";
    float: right;
    height: 40px;
    // background: #fff;
  }
  .btn {
    float: right;
    clear: both;
    cursor: pointer;
    color: #4876ff;
    font-size: 12px;
  }
}
.yigou_list_kong{
  display: flex;
  justify-content: center;
}
.yigou_list_kong img{
  width: 130px;
}
.yigou_list_kong div p{
  text-align: center;
  font-size: 14px;
  color: #ccc;
}
</style>
